import { Pipe, PipeTransform } from '@angular/core';

import { ProviderNetworkCompany } from '@sondermind/utilities/models-provider-network-company';

@Pipe({
  name: 'providerNetworkName',
  standalone: true
})
export class ProviderNetworkNamePipe implements PipeTransform {
  transform(pncId: number, pncLookup: Record<number, ProviderNetworkCompany>): string {
    if (!pncId || !pncLookup) {
      return '';
    }

    const pnc = pncLookup[pncId];
    const externalTitle = pnc?.externalTitle;

    return (externalTitle && externalTitle.trim() !== '' ? externalTitle : pnc?.name) || '';
  }
}
